<template>
    <div>
        <div class="row">
            <div :class="['col_12', {'loading_overlay': loading}]">
                <div class="card no_border">
                    <div class="card-header">
                        <div class="d_flex_btwn form_action_btn width_full">
                            <div class="card-title">{{ title }}</div>
                            <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.back') }}</router-link>
                        </div>
                    </div>
                    <div class="card-body pl_0 pr_0">
                        <div class="row">
                            <div class="col_4">
                                <div :class="['form-group', {'has_error': errorFor('lecture_title')}]">
                                    <label>{{ $t('sidebar.testLecture.lecture_title') }}</label>
                                    <input type="text" class="form_global" v-model="form.lecture_title">
                                    <v-errors :errors="errorFor('lecture_title')" />
                                </div>
                            </div>
                            <div class="col_4">
                                <div :class="['form-group', {'has_error': errorFor('status')}]">
                                    <label>{{ $t('common.status') }}</label>
                                    <div class="form_inline">
                                        <div class="form_radio">
                                            <input type="radio" id="active" value="1" v-model="form.status">
                                            <label for="active">{{ $t('common.active') }}</label>
                                        </div>
                                        <div class="form_radio">
                                            <input type="radio" id="inactive" value="0" v-model="form.status">
                                            <label for="inactive">{{ $t('common.inactive') }}</label>
                                        </div>
                                    </div>
                                    <v-errors :errors="errorFor('status')" />
                                </div>
                            </div>
                            <div class="col_4">
                                <div class="form-group ">
                                    <label>{{ $t('sidebar.lectureCommon.lecture_image') }}</label>
                                    <input type="file" class="form_global" ref="lecture_image" @input="onFileChange($event)" accept="image/png, image/gif, image/jpeg, image/webp">
                                    <v-errors :errors="errorFor('lecture_image')"></v-errors>
                                    <div class="video_list mt_10" v-if="tempPhoto || form.lecture_image">
                                        <div class="inner">
                                            <div class="inner_wrap">
                                            <img v-if="tempPhoto" :src="tempPhoto" alt="">
                                            <img v-else :src="form.lecture_image" alt="">
                                                <div class="icons">
                                                    <span @click.prevent="removeTempPhoto()"><i class="lni lni-trash"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="test_preview_videos.length">
                            <div class="col_12">
                                <div class="video_list">
                                    <div class="inner">
                                        <div class="inner_wrap">
                                            <img :src="test_preview_videos.thumbs" alt="" v-if="test_preview_videos.convert_status == 'Completed'">
                                            <img :src="baseUrl + 'assets/images/no_image.jpg'" alt="" v-else>
                                            <div class="icons">
                                                <span v-if="test_preview_videos.smil" @click.prevent="showVideo(test_preview_videos.smil)"><i class="lni lni-eye"></i></span>
                                                <span><i class="lni lni-trash" @click.prevent="removeVideo(test_preview_videos)"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('video_upload')}]">
                                    <label>{{ $t('sidebar.lectureCommon.video_upload') }}</label>
                                    <vue-dropzone ref="upload_dropzone" id="upload_dropzone"
                                        :class="{'dropzone_disable' : dropzoneDisable}"
                                        @vdropzone-removed-file="vremoved"
                                        @vdropzone-success-multiple="vsuccessMuliple"
                                        :options="dropzoneOptions"
                                        :duplicateCheck="true">
                                    </vue-dropzone>
                                    <v-errors :errors="errorFor('test_videos')" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col_12">
                                <div :class="['form-group', {'has_error': errorFor('lecture_desc')}]">
                                    <label>{{ $t('sidebar.testLecture.lecture_desc') }}</label>
                                    <text-editor-component 
                                        :id="'lecture_desc'" 
                                        :existingData="form.lecture_desc ? form.lecture_desc : ''" 
                                        @change="changeEditorValue"
                                    />
                                    <v-errors :errors="errorFor('lecture_desc')" />
                                </div>
                            </div>
                        </div>

                        <div class="d_flex_end form_action_btn">
                            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                            <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <video-modal v-if="videoModalShow" :showVideoModal="videoModalShow" :video="videoSmilFile" @closeModal="closeModal()"></video-modal>
    </div>
</template>

<script>
import vueDropzone from '../components/dropzone';
import TextEditorComponent from "@/components/TextEditorComponent";
import VideoModal from "../components/VideoModal.vue";
export default {
  components: { vueDropzone, TextEditorComponent, VideoModal },
  data() {
    return {
        baseUrl: process.env.VUE_APP_BASE,
        title: this.$t('sidebar.testLecture.addTestLecture'),
        cancelRouteName: 'test_lecture_list',
        form: {
            lecture_title: '',
            lecture_desc: '',
            lecture_image: '',
            status: 1,
        },
        tempPhoto: '',
        test_videos : [],
        test_preview_videos : [],
        dropzoneOptions: {
            url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
            thumbnailWidth: 150,
            maxFiles: 1,
            maxFilesize: 5368709120,
            uploadMultiple: true,
            allowMultiple: true,
            addRemoveLinks: true,
            acceptedFiles: "video/*",
            headers: {
                "Authorization": `Bearer `+ JSON.parse(localStorage.getItem('admin')).token
            }
        },
        dropzoneDisable: false,
        tempFile: null,
        videoModalShow: false,
        videoSmilFile: null,
    }
  },
  created() {

    if (this.$route.name === 'test_lecture_edit') {
      this.axios.get('/test-lectures/'+this.$route.params.id)
        .then((response) => {
            let lectureData = response.data.data;
            this.form.lecture_title = lectureData.lecture_title
            this.form.lecture_desc = lectureData.lecture_desc
            this.form.status = lectureData.status
            this.form.lecture_image = lectureData.lecture_image

            this.test_preview_videos = lectureData

            if(this.test_preview_videos.length){
                this.dropzoneDisable = true
            }

            let originalFile = {
                original_file: lectureData.original_filename,
                file: ''
            }

            this.test_videos = originalFile
        })
      this.title = this.$t('sidebar.testLecture.editTestLecture');
    }
  },
  methods: {
    onFileChange(e) {
        this.form.lecture_image = e.target.files[0]
        this.tempPhoto = URL.createObjectURL(e.target.files[0]);
    },
    removeTempPhoto() {
        this.tempPhoto = ''
        this.form.lecture_image = ''
        this.$refs.lecture_image.value = null;
    },
    changeEditorValue(editorId, data){
      this.form[editorId] = data
    },
    vremoved(file) {
        let filename = file.name;
        this.axios.post('/delete-lecture-local-video', { 'name' : filename.file})
          .then(() => {
            this.showSuccessMsg('Video Removed Successfully!')
            this.test_videos = [];

            this.dropzoneDisable = false
        });
    },
    vsuccessMuliple(file, response) {
        response.forEach((element,index) => {
            let lectureOriginalFile = {
                original_file: file[index].name,
                file: element.original_filename
            }
            this.test_videos = lectureOriginalFile
        });

        this.dropzoneDisable = true
    },
    removeVideo(video){
        let videoId = video.id
        this.axios.post('/delete-lecture-video', { 'id' : videoId})
        .then(() => {
            this.showSuccessMsg('Video Removed Successfully!')
            this.test_videos = [];

            this.test_preview_videos=[];

            this.dropzoneDisable = false
        });
    },
    showVideo(smil){
        this.videoSmilFile = smil
        this.videoModalShow = true
    },
    closeModal(){
      this.openModal = false
      this.videoModalShow = false
    },
    submit() {
        this.allErrors = null;
        this.loading = true;

        if (this.$route.name === 'test_lecture_edit') {
            this.loading = true;
            this.errors = null;

            let formData = new FormData();

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            formData.append('test_videos', JSON.stringify(this.test_videos))
            formData.append('status', JSON.stringify(this.form.status))

            formData.append('_method','PATCH')

            this.axios.post('/test-lectures/'+this.$route.params.id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(() => {
                this.$router.push({name: 'test_lecture_list'});
                this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            });
        } else {
            let formData = new FormData()

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            formData.append('test_videos', JSON.stringify(this.test_videos))
            formData.append('status', JSON.stringify(this.form.status))

            this.axios.post('/test-lectures', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(() => {
                this.$router.push({name: 'test_lecture_list'});
                this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            });
        }
    }
  }
}
</script>

<style scoped>
    .dropzone_disable {
        pointer-events: none;
        cursor: default;
    }
    .dropzone_disable .dropzone .dz-message{
        display: none !important;
    }
</style>
